import { render } from "./The10YearPlan.vue?vue&type=template&id=23212702&scoped=true"
import script from "./The10YearPlan.vue?vue&type=script&lang=js"
export * from "./The10YearPlan.vue?vue&type=script&lang=js"

import "./The10YearPlan.vue?vue&type=style&index=0&id=23212702&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23212702"]])

export default __exports__